module.exports = __webpack_public_path__ + "img/BANNER.21eb74eb.svg";